// src/store/index.js
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
//vuex基本使用方法
/*
1.2使用数据
第一种：通过store直接访问
第二种：通过mapState辅助函数（语法简洁）
mapState是 Vuex 提供的一个辅助函数，用于将 Vuex 的状态映射到 Vue 组件的计算属性中

2.mutations（修改数据）
由于vuex同样遵循单项数据流，即组件中不能直接修改仓库数据
2.1通过mutations定义方法修改数据
注：1.提交的名字要与1.中定义的方法名相同
    2.mutations定义方法可传参，但第一个参数必须为state
    3.mutations参数只能多传一个，如果存在需要传入多个参数的情况，需打包成对象或数组的形式
    this.$store.commit('add'，obj)

*/
export default new Vuex.Store({
  state: {
    //即状态 是一个全局的数据和data类似 要做好持久化 不然刷新页面数据就会丢失
    user: JSON.parse(localStorage.getItem('user')) || null,
    jwt: localStorage.getItem('jwt') || '',
    taskList: []
  },
  mutations: {
    setUser(state, user) {
      state.user = user
      //需要对user持久化
      localStorage.setItem('user', JSON.stringify(user)); // 保存到 localStorage
      localStorage.setItem('jwt', user.token)
    },
    clearUser(state) {
      state.user = null;
      localStorage.removeItem('user'); // 清除 localStorage
      localStorage.removeItem('jwt')
    },
    addTask(state, taskId) {
      state.taskList.push(taskId)
    },
    clearTask(state) {
      //清空任务
      state.taskList = []
    }
  },
  actions: {
  },
  getters: {
    vipIsAvailable(state) {
      let user = state.user
      if (user == null) {
        return false
      }
      if (new Date().getTime() - user.expiration < 0) {
        return true
      }
      return false
    }
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js